RivalIQ.module('utils.hubSpot', function (hubSpot, App, Backbone, Marionette, $, _) {

    'use strict';

    function getHubSpotCookie() {
        const cookies = window.document.cookie.split('; ').reduce(function (memo, value) {
            const pair = value.split('=');
            memo[pair[0]] = pair[1];
            return memo;
        }, {});

        return cookies.hubspotutk;
    }

    hubSpot.augmentHubSpotFormData = function (model) {
        const values = {
            hubspotutk: getHubSpotCookie(),
            pageName: document.title,
            pageUrl: window.location.href
        };

        _.forEach(values, function (value, key) {
            if (!model.get(key) && value) {
                model.set(key, value);
            }
        });
    };

});
